import { render, staticRenderFns } from "./TreatmentPage.vue?vue&type=template&id=065ac3f4"
import script from "./TreatmentPage.vue?vue&type=script&lang=js"
export * from "./TreatmentPage.vue?vue&type=script&lang=js"
import style0 from "./TreatmentPage.vue?vue&type=style&index=0&id=065ac3f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports